export default __webpack_public_path__ + "static/media/poster12.a5218e4f.png";